/* global __WEB__ */

import React from 'react';
import Helmet from 'react-helmet';

import cssVars from '../styles/_variables.scss';

// @TODO:
// Make new image with proper dimensions
// Use keywords
// URL isn't updating

class Meta extends React.Component {
    static propTypes = {
        pageName: React.PropTypes.string,
    }

    shouldComponentUpdate(nextProps) {
        return this.props.pageName !== nextProps.pageName;
    }

    render() {
        const { pageName } = this.props;

        const title = pageName ? `${pageName} - OmniEkonomi` : 'OmniEkonomi';
        const url = __WEB__ ? window.location : 'https://bors.omniekonomi.se/';
        const image = '/image/launch@2x.png';
        // eslint-disable-next-line
        const description = 'Sveriges mest nedladdade ekonomiapp Omni Ekonomi är framtagen för den nya tidens affärsmänniska, med alla världens medier samlade i en app. Vi ger dig det allra senaste från världens börser samt från såväl svenska som internationella företag. Vi ger även alla perspektiv på tillståndet i den svenska- och världsekonomin.';

        const helmetMeta = [
            { name: 'title', content: title },
            { name: 'description', content: description },
            { name: 'keywords', content: 'Börs' },

            { property: 'al:ios:app_store_id', content: '1293669438' },
            { property: 'al:ios:app_name', content: 'omniekonomi.se' },

            { name: 'theme-color', content: cssVars['color-main'] },
            { name: 'msapplication-navbutton-color', content: cssVars['color-main'] },

            { name: 'application-name', content: 'OmniEkonomi Börs' },
            { name: 'apple-mobile-web-app-capable', content: 'yes' },
            { name: 'apple-mobile-web-app-title', content: 'OmniEkonomi' },
            { name: 'msapplication-starturl', content: '/' },

            { name: 'robots', content: 'noindex, nofollow' },
            { name: 'googlebot', content: 'noindex, nofollow' },
            {
                name: 'google-site-verification',
                content: 'hvMcVgCHBzEjL17ifC0t7Tso-MRE6JQiAoHB9XcaoGc',
            },
            { name: 'google-play-app', content: 'app-id=se.omniekonomi' },
            { name: 'apple-itunes-app', content: 'app-id=1293669438, app-argument=https://omniekonomi.se/' },

            { property: 'og:site_name', content: 'OmniEkonomi' },

            { property: 'og:url', content: url },
            { property: 'og:title', content: title },
            { property: 'og:description', content: description },
            { property: 'og:type', content: 'website' },
            { property: 'og:image', content: image },

            { name: 'twitter:card', content: 'summary_large_image' },
            { name: 'twitter:site', content: '@omniekonomi' },
            { name: 'twitter:creator', content: '@omniekonomi' },
            { name: 'twitter:title', content: title },
            { name: 'twitter:description', content: description },
            { name: 'twitter:image', content: image },
        ];

        return (<Helmet
            title={title}
            htmlAttributes={{ lang: 'sv' }}
            link={[
                { href: '//acdn.adnxs.com', rel: 'preconnect' },
                { href: '//acdn.adnxs.com', rel: 'dns-prefetch' },
                { href: '//ib.adnxs.com', rel: 'preconnect' },
                { href: '//ib.adnxs.com', rel: 'dns-prefetch' },
                { href: '//cdn.adnxs.com', rel: 'preconnect' },
                { href: '//cdn.adnxs.com', rel: 'dns-prefetch' },
            ]}
            meta={helmetMeta}
        />);
    }

}

export default Meta;



/** WEBPACK FOOTER **
 ** /src/shared/containers/Meta.js
 **/